<template>
  <div>
    <FiltroCliente
      @filtrar-cliente="adicionarFiltros"
    />
    <FiltroAparelho
      @filtrar-aparelho="adicionarFiltros"
    />
    <FiltroCupons
      @filtrar-cupons="adicionarFiltros"
    />
    <FiltroStatusPedido
      @filtrar-status-pedido="adicionarFiltros"
    />
    <FiltroTipoPedido
      @filtrar-tipo-pedido="adicionarFiltros"
    />
    <v-btn color="success" @click="filtrar">Filtrar</v-btn>
  </div>
</template>

<script>
import FiltroAparelho from './Pedidos/FiltroAparelho'
import FiltroCupons from './Pedidos/FiltroCupons'
import FiltroStatusPedido from './Pedidos/FiltroStatusPedido'
import FiltroTipoPedido from './Pedidos/FiltroTipoPedido'
import FiltroCliente from './Pedidos/FiltroCliente'

export default {
  name: 'FiltroPedidos',
  components: {
    FiltroAparelho,
    FiltroCupons,
    FiltroStatusPedido,
    FiltroTipoPedido,
    FiltroCliente
  },
  data() {
    return {
      filtros: {}
    }
  },
  methods: {
    filtrar() {
      const filtros = this.serializarFiltros()
      this.$emit('filtrar', filtros)
    },
    adicionarFiltros(value) {
      this.filtros = {
        ...this.filtros,
        ...value
      }
    },
    serializarFiltros() {
      let args = ''
      args += this.serializarCampo('com_cupom')
      args += this.serializarArray('status_pedidos')
      args += this.serializarCampo('aparelho', true)
      args += this.serializarCampo('tipo')
      if (this.filtros.cliente !== undefined && this.filtros.cliente.length > 0) {
        args += this.serializarCampo('cliente', true)
      }
      return args
    },
    serializarCampo(campo, str = false) {
      let item = this.filtros[campo]
      let retorno = ''
      if (item !== undefined && item !== null) {
        retorno = `, ${campo}: `
        retorno += str ? `"${item}"` : `${item}`
      }
      return retorno
    },
     serializarArray(campo, str = false) {
      let arr = this.filtros[campo]
      let itens = ''
      if (arr !== undefined) {
        if (arr.length > 0) {
          itens += str ? `"${arr[0]}"` : `${arr[0]}`
        }
        for (let i = 1; i < arr.length; i ++) {
          itens += str ? `, "${arr[i]}"` : `, ${arr[i]}`
        }
      }
      return `, ${campo}: [${itens}]`
    },
  }
}
</script>
